/**
 * Function to get valid supported mimeType for different browsers
 * @param media "video" | "audio"
 * @returns mimeType string
 */
const getSupportedMimeTypes = (media: 'video' | 'audio' = 'video') => {
  const videoTypes = ['webm', 'ogg', 'mp4', 'x-matroska'];
  const audioTypes = ['webm', 'ogg', 'mp3', 'x-matroska'];

  const videoCodecs = ['h264', 'vp9', 'vp8', 'avc1', 'opus', 'pcm'];
  const audioCodecs = ['opus', 'pcm'];

  const supported: Array<string> = [];
  const isSupported = MediaRecorder.isTypeSupported;
  const types = media === 'video' ? videoTypes : audioTypes;
  const codecs = media === 'video' ? videoCodecs : audioCodecs;

  types.forEach((type: string) => {
    const mimeType = `${media}/${type}`;

    // without codecs
    isSupported(mimeType) && supported.push(mimeType);

    // with codecs
    codecs.forEach((codec) =>
      isSupported(`${mimeType};codecs=${codec}`) &&
      !supported.includes(`${mimeType};codecs=${codec}`)
        ? supported.push(`${mimeType};codecs=${codec}`)
        : null
    );
  });

  return supported;
};

export const getExtensionMimeTypes = (mimeType: string) => {
  const [_media, type] = mimeType.split('/');
  const [typeWithoutCodecs] = type.split(';');

  if (typeWithoutCodecs === 'x-matroska') return 'mkv';

  return typeWithoutCodecs;
};

/* Video: [
  0: "video/webm"
  1: "video/webm;codecs=vp9"
  2: "video/webm;codecs=vp8"
  3: "video/webm;codecs=avc1"
  4: "video/webm;codecs=h264"
  5: "video/webm;codecs=opus"
  6: "video/webm;codecs=pcm"
  7: "video/x-matroska"
  8: "video/x-matroska;codecs=vp9"
  9: "video/x-matroska;codecs=vp8"
  10: "video/x-matroska;codecs=avc1"
  11: "video/x-matroska;codecs=h264"
  12: "video/x-matroska;codecs=opus"
  13: "video/x-matroska;codecs=pcm"
] */

/* Audio [
  0: "audio/webm"
  1: "audio/webm;codecs=opus"
  2: "audio/webm;codecs=pcm"
] */

export default getSupportedMimeTypes;

/**
 * Stat: 1920x1080, 60fps, 2s
 * 0. webm: 1.83 MB | [1.49 MB, 26.5s]
 * 1. webm;codecs=vp9: 1.08 MB | [1.14 MB, 18.57s]
 * 2. webm;codecs=vp8: 1.74 MB | [1.48 MB, 32.23s]
 * 3. webm;codecs=avc1: 1.83 MB | [1.49 MB, 26.5s]
 * 4. webm;codecs=h264: 1.83 MB | [1.49 MB, 22.18s]
 * 5. webm;codecs=opus: 1.08 MB | [1.14 MB, 30.97s]
 * 6. webm;codecs=pcm: 1.83 MB | [1.49 MB, 32.07s]
 * 7. x-matroska: 1.85 MB | [1.88 MB, 34.83s]
 * 8. x-matroska;codecs=vp9: 1.12 MB | [0.96 MB, 19.91s]
 * 9. x-matroska;codecs=vp8: 1.91 MB | [1.54 MB, 27.86s]
 * 10. x-matroska;codecs=avc1: 2.58 MB | [1.28 MB, 21.56s]
 * 11. x-matroska;codecs=h264: 2.49 MB | [1.46 MB, 22.07s]
 * 12. x-matroska;codecs=opus: 1.90 MB | [1.65 MB, 26.42s]
 * 13. x-matroska;codecs=pcm: 1.92 MB | [2.01 MB, 33.55s]
 */
